import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const postDiscountCoupan = async (data, token) => {
  const res = await axios({
    method: "post",
    url: baseurl + `/applyCoupon`,
    headers: {
      token: token,
    },
    data: data,
  });
  return res.data;
};
